module.exports = __webpack_public_path__ + "static/logo-ibew-local-11-2f2fa8127509dd7c19fa82bf3fe9fa08.png";